import React from "react"
import { initialState, State } from "./state"

export const DispatchContext = React.createContext<any>(null)
export const StateContext = React.createContext<State>(initialState)